import { React, useState, useEffect } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../Context/LanguageContext';

import FetchModule from '../../Model/Share/Network/FetchModule.js';

import ExitButtonImg from '../../image/BlackDeleteButton.png';

export default function OnSitePaymentModal(props) {
  const {
    selectedMembership,
    selectedPaymentOptions,
    selectedLockerPaymentOptions,
    onClickOnSitePayment,
    onClickExit
  } = props;
  const { t } = useLanguage();

  const [totalPrice, setTotalPrice] = useState(0);

  // 스크롤 제어 //
  useEffect(() => {
    document.body.style = `overflow: hidden`;
    return () => document.body.style = `overflow: auto`;
  }, [])

  // 총 가격 산정하기 //
  useEffect(() => {
    let totalPrice = 0;

    for (let i = 0; i < selectedPaymentOptions.length; i++) {
      if (selectedPaymentOptions[i].price !== '') totalPrice += parseInt(selectedPaymentOptions[i].price.toString().replaceAll(',', ''));
    }

    for (let i = 0; i < selectedLockerPaymentOptions.length; i++) {
      if (selectedLockerPaymentOptions[i].price !== '') totalPrice += parseInt(selectedLockerPaymentOptions[i].price.toString().replaceAll(',', ''));
    }

    setTotalPrice(totalPrice);
  }, [selectedPaymentOptions, selectedLockerPaymentOptions])
  // function onClickOnSitePayment() {
  //   if (isInProgress) {
  //     alert('결제를 진행중입니다!');
  //     return;
  //   }

  //   setIsInProgress(true);

  //   let approvalDate = getApprovalDate();

  //   let requestData = {
  //     merchantUid: merchantUid,
  //     cardPrice: price,
  //     cashPrice: cashPrice,
  //     discount: discount,
  //     notReceived: notReceived,
  //     approvalDate: approvalDate
  //   }
    
  //   const fetchModule = new FetchModule();
  //   (
  //     async () => {
  //       const responseData = await fetchModule.postDataVersion2('sales/onSite/effectiveness', 'POST', requestData);

  //       if (responseData.status === 200) {
  //         // console.log('Effect Success');
  //         onRegist(responseData.data);
  //         setIsInProgress(false);
  //       }
  //       else if (responseData.status === 201) {
  //         alert('올바르지 않은 요청입니다');
  //         setIsInProgress(false);
  //         return;
  //       }
  //       else if (responseData.status === 202) {
  //         alert('이미 결제가 진행된 건 입니다.');
  //         setIsInProgress(false);
  //         return;
  //       }
  //       else if (responseData.status === 204) {
  //         alert('결제 내역이 존재하지 않습니다.');
  //         setIsInProgress(false);
  //         return;
  //       }
  //       // cancel();
  //     }
  //   )();
  // }

  return (
    <TopLevelWrapper>
      <ModalView>
        <TotalWrapper>
          <TitleLineWrapper>
            <Title>{t('onSitePaymentModal.productInfo')}</Title>
            <ExitButton src={ExitButtonImg} onClick={onClickExit} />
          </TitleLineWrapper>
          <ProductInfoBox>
            <Logo src='https://picture.link-zone.org/ZoneLogo.png' />
            <TextWrapper>
              <TextEng>Link Zone</TextEng>
              <TextKor>{selectedMembership.name}</TextKor>
              <TextExplanation>{t('onSitePaymentModal.validityDays').replace('{days}', selectedMembership.validity)}</TextExplanation>
            </TextWrapper>
          </ProductInfoBox>
          <PriceWrapper>
            <Title>{t('onSitePaymentModal.finalPaymentAmount')}</Title>
            <LayerWrapper style={{ marginTop: `24px` }}>
              <TextNormal style={{ color: `#595959` }}>{t('onSitePaymentModal.paymentAmount')}</TextNormal>
              <DivisionLine />
              <TextNormal style={{ color: `#595959` }}>{totalPrice.toLocaleString('ko-KR')}{t('onSitePaymentModal.currencyUnit')}</TextNormal>
            </LayerWrapper>
            <LayerWrapper style={{ marginTop: `8px` }}>
              <TextBold style={{ color: `#232323` }}>{t('onSitePaymentModal.finalAmount')}</TextBold>
              <DivisionLine />
              <TextBold style={{ color: `#FF8B48` }}>{totalPrice.toLocaleString('ko-KR')}{t('onSitePaymentModal.currencyUnit')}</TextBold>
            </LayerWrapper>
          </PriceWrapper>
          <OnSiteWrapper>
            <OnSitePayment onClick={onClickOnSitePayment}>{t('onSitePaymentModal.payOnSite')}</OnSitePayment>
          </OnSiteWrapper>
        </TotalWrapper>
      </ModalView>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  z-index: 1100;

  width: 100vw;
  height: 100vh;

  background-color: rgba(0, 0, 0, 0.3);

  transition: all 0.3s ease-in-out;
`;

const ModalView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 378px;
  height: 416px;

  border-radius: 30px;
  background-color: #FFFFFF;
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;
`;

const TitleLineWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const Title = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #232323;

  margin: 0 0 0 0;
`;

const ExitButton = styled.img`
  width: 16px;
  height: 16px;

  &:hover {
    cursor: pointer;
  }
`;

const ProductInfoBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  gap: 16px;
  margin: 24px 0 0 0;
  padding: 0 16px 0 16px;

  width: 290px;
  height: 100px;

  border-radius: 15px;
  background-color: #FF8B48;
`;

const Logo = styled.img`
  width: 60px;
  height: 60px;

  margin: 0 0 0 0;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
`;

const TextEng = styled.p`
  font-family: Poppins-Bold;
  font-size: 14px;

  color: #FFFFFF;

  margin: 0 0 0 0;
`;

const TextKor = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #FFFFFF;

  margin: 0 0 0 0;
`;

const TextExplanation = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 12px;

  color: rgba(255, 255, 255, 0.5);

  margin: 0 0 0 0;
`;

const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin: 24px 0 0 0;
  padding: 24px 0 0 0;

  width: 322px;

  border-top: 1px solid #ECECEC;
`;

const LayerWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const TextBold = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 14px;

  // color: #232323;

  margin: 0 0 0 0;
`;

const TextNormal = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  // color: #232323;

  margin: 0 0 0 0;
`;

const DivisionLine = styled.div`
  width: 160px;
  height: 1px;

  border-top: 1px dashed #ECECEC;
`;

const OnSiteWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 36px;

  width: 100%;
`;

const OnSitePayment = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 38px;

  border: 1px solid #E0E0E0;
  border-radius: 15px;
  background-color: #FFFFFF;

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #BDBDBD;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    border: 1px solid #232323;
    color: #232323;
  }
`;


const Text = styled.div`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;